import { IS_UK, IS_AU } from "helpers/application"

const is_uk_au = () => IS_UK() || IS_AU()
const worryFreeAU = () => (IS_AU() ? "_au" : "")
const worryFreeUK = () => (IS_UK() ? "_uk" : "")

export const banner = () => ({
  contain: false,
  image: {
    alt: "Diamond Stud Earrings",
    fallback: `${require("images/landings/diamond_stud_earrings/banner_desktop.jpg")}`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${require("images/landings/diamond_stud_earrings/banner_mobile.jpg")} 767w,
                  ${require("images/landings/diamond_stud_earrings/banner_mobile_2x.jpg")} 1534w`,
      },
      {
        media: "(min-width: 768px) and (max-width: 1023px)",
        sizes: "100vw",
        srcSet: `
          ${require("images/landings/diamond_stud_earrings/banner_tablet.jpg")} 1x,
          ${require("images/landings/diamond_stud_earrings/banner_tablet_2x.jpg")} 2x`,
      },
      {
        media: "(min-width: 1024px)",
        sizes: "100vw",
        srcSet: `
          ${require("images/landings/diamond_stud_earrings/banner_desktop.jpg")} 1x,
          ${require("images/landings/diamond_stud_earrings/banner_desktop_2x.jpg")} 2x`,
      },
    ],
  },
  style: {
    mb: { _: 5, tablet: 6 },
    pb: { _: "74.32%", desktop: "19.11%", tablet: "35.84%" },
  },
  textarea: {
    style: {
      left: { desktop: "8%", tablet: "4%" },
      top: { _: "10%", tablet: "50%" },
    },
    texts: [
      {
        style: {
          fontSize: { _: 25, tablet: 32 },
          fontWeight: 500,
          mb: { _: 1, desktop: 2 },
        },
        text: "Diamond Studs",
        type: "title",
      },
      {
        style: {
          fontSize: { desktop: 18 },
          letterSpacing: "0.2px",
          lineHeight: "1.3",
          mb: 0,
          px: { _: 2, tablet: 0 },
        },
        text:
          "Timeless and elegant, our diamond stud earrings feature a choice of natural or lab diamonds, quality-crafted in white or yellow gold.",
        type: "description",
      },
    ],
  },
})

export const diamondBlock = () => [
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0152-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0152-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0152-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0152-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0152-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0152-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0152-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0152-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "4-Prong Classic",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "A timeless design, these sparkling earrings add a classic elegance to your style.",
          type: "description",
        },
      ],
    },
    video: {
      name: "4-prong-JWE0152-slow",
      thumb: "thumb_4_prong",
    },
  },
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0157-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0157-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0157-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0157-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0157-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0157-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0157-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0157-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "5-Prong Scallop",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "This delicate setting is designed to lift your diamonds into the light, enhancing their sparkle.",
          type: "description",
        },
      ],
    },
    video: {
      name: "5-prong-JWE0157-slow",
      thumb: "thumb_5_prong",
    },
  },
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0146-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0146-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0146-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0146-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0146-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0146-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0146-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0146-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "3-Prong Martini",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "Perfect for the minimalist, this style gives a graceful floating appearance to your diamonds.",
          type: "description",
        },
      ],
    },
    video: {
      name: "3-prong-Jwe0146-slow",
      thumb: "thumb_3_prong",
    },
  },
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0151-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0151-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0151-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0151-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0151-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0151-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0151-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0151-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "6-Prong Scallop",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "This intricate setting is designed to lift your diamonds into the light, enhancing their sparkle.",
          type: "description",
        },
      ],
    },
    video: {
      name: "6-prong-Jwe0151-slow",
      thumb: "thumb_6_prong",
    },
  },
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0206-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0206-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0206-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0206-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0206-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0206-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0206-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0206-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "Halo Diamond Studs",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "This stylish setting accents your center diamonds with a halo of stones for maximum sparkle.",
          type: "description",
        },
      ],
    },
    video: {
      name: "halo-cropped-halo-slow",
      thumb: "thumb_halo",
    },
  },
  {
    details: [
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          image_url: "/products/JWE0145-1",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/55.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0145-1",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          image_url: "/products/JWE0145-2",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/75.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0145-2",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          image_url: "/products/JWE0145-3",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0145-3",
      },
      {
        image: {
          desktop: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          desktop_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          fallback: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          image_url: "/products/JWE0145-4",
          mobile: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          mobile_2x: `${require("images/landings/diamond_stud_earrings/stone-size/1-25.svg")}`,
          style: { pb: { _: 1, tablet: 2 }, width: "130px" },
        },
        style_code: "JWE0145-4",
      },
    ],
    texts: {
      texts: [
        {
          style: { fontSize: 24, fontWeight: 500 },
          text: "Twisted-Rope Studs",
          type: "title",
        },
        {
          style: {
            lineHeight: "1.3",
            mb: { _: 1, tablet: 2 },
            mx: "auto",
            width: { _: "90%", tablet: "100%" },
          },
          text:
            "A beautiful twisted-rope design that frames your diamonds for a bold, dramatic look.",
          type: "description",
        },
      ],
    },
    video: {
      name: "twisted-Jwe0145-rev2-slow",
      thumb: "thumb_twisted",
    },
  },
]

export const featuringPremium = () => ({
  features: {
    desktop: `${require("images/landings/diamond_stud_earrings/valueFactors_desktop.svg")}`,
    desktop_2x: `${require("images/landings/diamond_stud_earrings/valueFactors_desktop.svg")}`,
    fallback: `${require("images/landings/diamond_stud_earrings/valueFactors_desktop.svg")}`,
    mobile: `${require("images/landings/diamond_stud_earrings/valueFactors_mobile.svg")}`,
    mobile_2x: `${require("images/landings/diamond_stud_earrings/valueFactors_mobile.svg")}`,
    style: {
      width: { _: "70%", desktop: "58%", tablet: "88%", widescreen: "64%" },
    },
  },
  valueFactors: {
    desktop: `${require("images/landings/diamond_stud_earrings/value_factors_title.svg")}`,
    desktop_2x: `${require("images/landings/diamond_stud_earrings/value_factors_title.svg")}`,
    fallback: `${require("images/landings/diamond_stud_earrings/value_factors_title.svg")}`,
    mobile: `${require("images/landings/diamond_stud_earrings/value_factors_title.svg")}`,
    mobile_2x: `${require("images/landings/diamond_stud_earrings/value_factors_title.svg")}`,
    style: {
      mb: { _: 1, tablet: 0 },
      width: { _: "140px", tablet: "160px", widescreen: "170px" },
    },
  },
})

export const worryFree = () => ({
  alt: "worry Free",
  contain: true,
  fallback: `${require(`images/landings/diamond_stud_earrings/worry_free_desktop${worryFreeAU()}${worryFreeUK()}.jpg`)}`,
  srcSet: [
    {
      media: "(max-width: 767px)",
      sizes: "100vw",
      srcSet: `${require(`images/landings/diamond_stud_earrings/worry_free_mobile${worryFreeAU()}${worryFreeUK()}.jpg`)} 767w,
                  ${require(`images/landings/diamond_stud_earrings/worry_free_mobile${worryFreeAU()}${worryFreeUK()}_2x.jpg`)} 1534w`,
    },
    {
      media: "(min-width: 768px)",
      sizes: "100vw",
      srcSet: `
          ${require(`images/landings/diamond_stud_earrings/worry_free_desktop${worryFreeAU()}${worryFreeUK()}.jpg`)} 1x,
          ${require(`images/landings/diamond_stud_earrings/worry_free_desktop${worryFreeAU()}${worryFreeUK()}_2x.jpg`)} 2x`,
    },
  ],
  style: { contain: true, mb: 3 },
})

export const giftPackage = () => ({
  contain: false,
  image: {
    alt: "Packaged For Gifting",
    contain: false,
    fallback: `${require("images/landings/diamond_stud_earrings/gift_package_desktop.jpg")}`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${require("images/landings/diamond_stud_earrings/gift_package_mobile.jpg")} 767w,
                  ${require("images/landings/diamond_stud_earrings/gift_package_mobile.jpg")} 1534w`,
      },
      {
        media: "(min-width: 768px) and (max-width: 1023px)",
        sizes: "100vw",
        srcSet: `
          ${require("images/landings/diamond_stud_earrings/gift_package_tablet.jpg")} 1x,
          ${require("images/landings/diamond_stud_earrings/gift_package_tablet_2x.jpg")} 2x`,
      },
      {
        media: "(min-width: 1024px)",
        sizes: "100vw",
        srcSet: `
          ${require("images/landings/diamond_stud_earrings/gift_package_desktop.jpg")} 1x,
          ${require("images/landings/diamond_stud_earrings/gift_package_desktop_2x.jpg")} 2x`,
      },
    ],
  },
  style: { removeRatio: true },
  textarea: {
    style: {
      left: { tablet: "12%" },
      top: { _: "7%", desktop: "48%", tablet: "56%", widescreen: "50%" },
    },
    texts: [
      {
        style: {
          fontSize: 24,
          fontWeight: 500,
          mb: { _: 1, desktop: 2 },
        },
        text: "Packaged For Gifting",
        type: "title",
      },
      {
        style: {
          fontSize: { desktop: 18 },
          letterSpacing: "0.2px",
          lineHeight: "1.3",
        },
        text:
          "Orders include a deluxe velvet pouch or premium black box, an order packing slip and Certificate of Authenticity.",
        type: "description",
      },
    ],
  },
})

export const moreToExplore = () => ({
  image: {
    alt: "more to explore",
    contain: false,
    fallback: `${require(`images/landings/diamond_stud_earrings/more_to_explore_${
      is_uk_au() ? "desktop_uk_au" : "desktop"
    }.svg`)}`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${require(`images/landings/diamond_stud_earrings/more_to_explore_${
          is_uk_au() ? "mobile_uk_au" : "mobile"
        }.svg`)} 767w,
                  ${require(`images/landings/diamond_stud_earrings/more_to_explore_${
                    is_uk_au() ? "mobile_uk_au" : "mobile"
                  }.svg`)} 1534w`,
      },
      {
        media: "(min-width: 768px)",
        sizes: "100vw",
        srcSet: `
          ${require(`images/landings/diamond_stud_earrings/more_to_explore_${
            is_uk_au() ? "desktop_uk_au" : "desktop"
          }.svg`)} 1x,
          ${require(`images/landings/diamond_stud_earrings/more_to_explore_${
            is_uk_au() ? "desktop_uk_au" : "desktop"
          }.svg`)} 2x`,
      },
    ],
    style: {
      height: { _: "auto", tablet: "279px" },
      px: { _: 3, tablet: 0 },
      width: { _: "668px", tablet: "645px" },
    },
  },
  style: {
    margin: "auto",
    removeRatio: true,
    style: { cursor: "pointer" },
    width: { tablet: "645px" },
  },
  textarea: {
    style: {
      left: { desktop: "22%", tablet: "30%" },
      top: { _: "75%" },
    },
    texts: [
      {
        base_style: "button",
        style: {
          style: {
            border: "solid 1px black",
            fontSize: { _: 14, desktop: 16 },
            padding: "8px 48px",
          },
        },
        text: "Shop All",
        type: "link",
        url: "/diamond-stud-earrings",
      },
    ],
  },
})
